import { CommonCreateSelect } from "components/Common/Common";
import { useFormikContext } from "formik";
import { errorMessageToast, getGuardianOptionLabel } from "helpers/common";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import { useLazyCoordinatorLookupQuery, useLazyParentLookupQuery, useLazyTeacherLookupQuery } from "store/services/utility";

const GuardianPicker = ({ index, type, name, placeholder, schoolId, isSchoolIdRequired = false, handleBlur, onInputChange }) => {
  const [guardianList, setGuardianList] = useState([]);

  const { setFieldValue } = useFormikContext();

  const [getTeachersList, { isLoading: getTeachersLoading }] = useLazyTeacherLookupQuery();
  const [getParentsList, { isLoading: getParentsLoading }] = useLazyParentLookupQuery();
  const [getCoordinatorsList, { isLoading: getCoordinatorsLoading }] = useLazyCoordinatorLookupQuery();

  const getGuardianLookup = async (search, type, schoolId) => {
    try {

      let result = null;

      if (type == "parents") {
        result = await getParentsList(search).unwrap();
      } else if (type == "coordinators") {
        result = await getCoordinatorsList(search).unwrap();
      } else {
        if (isSchoolIdRequired) {
          if(schoolId){
            result = await getTeachersList({search, schoolId}).unwrap();
          }
          else{
            errorMessageToast("Please select school first");
            return;
          }
        }
        else{
          result = await getTeachersList({search}).unwrap();
        }
      };

      if (!result?.length) {
        return;
      }

      const guardianList = result?.map((item) => ({ value: item.id, label: getGuardianOptionLabel(item), ...item }));
      setGuardianList(guardianList)

    } catch (err) {
      console.error("error fetching guardians", err)
    };
  };

  const handleSearch = useCallback(debounce((search = "", type) => {
    if (search) getGuardianLookup(search, type, schoolId);
    else {
      setGuardianList([]);
    }
  }, 500), [schoolId]);

  return (
    <CommonCreateSelect
      name={name}
      placeholder={placeholder}
      handleBlur={() => setGuardianList([])}
      creatable={true}
      onInputChange={(e) => handleSearch(e, type)}
      option={guardianList}
      isLoading={getTeachersLoading || getParentsLoading || getCoordinatorsLoading}
      onChange={(selected) => {
        let guardian = guardianList?.find(guardian => guardian.id === selected?.value);
        let selectedValue = {
          ...selected,
          label: guardian?.lastname
        };
        if (!guardian) {
          setFieldValue(`${type}.${index}.lastname`, selected);
          setFieldValue(`${type}.${index}.id`, null);
          setFieldValue(`${type}.${index}.firstname`, "");
          setFieldValue(`${type}.${index}.email`, "");
          setFieldValue(`${type}.${index}.phone`, "");
          return;
        }
        setFieldValue(`${type}.${index}.id`, guardian.id);
        setFieldValue(`${type}.${index}.lastname`, selectedValue);
        setFieldValue(`${type}.${index}.firstname`, guardian?.firstname);
        setFieldValue(`${type}.${index}.email`, guardian?.email);
        setFieldValue(`${type}.${index}.phone`, guardian?.phone);
        setGuardianList([])
      }}

    />
  )
}

export default GuardianPicker